import { ref as l } from "vue";
import { dom as i } from "./index339.js";
import { getTextValue as m } from "./index554.js";
function s(a) {
  let r = l(""), t = l("");
  return () => {
    let e = i(a);
    if (!e) return "";
    let u = e.innerText;
    if (r.value === u) return t.value;
    let o = m(e).trim().toLowerCase();
    return r.value = u, t.value = o, o;
  };
}
export {
  s as useTextValue
};
